import { useCallback, useEffect, useState } from 'react';

/** `[from, to]` in seconds. */
export type Range = [number, number];

// Ranges closer together than this are one range.
const joinGapSeconds = 0.05;

/** Adds a range to a list of ranges and merges what now touches. Returns a new list. */
export const addRange = (ranges: Range[], added: Range): Range[] => [...ranges, added]
  .map(([from, to]): Range => [from, to])
  .sort((a, b) => a[0] - b[0])
  .reduce<Range[]>((merged, range) => {

    const last = merged[merged.length - 1];

    if (last && range[0] <= last[1] + joinGapSeconds) {

      last[1] = Math.max(last[1], range[1]);
      return merged;

    }

    return [...merged, range];

  }, []);

const read = (storageKey: string): Range[] => {

  try {

    const stored: unknown = JSON.parse(sessionStorage.getItem(storageKey));

    return Array.isArray(stored) ? stored.filter((range) => Array.isArray(range) && range.every(Number.isFinite)) : [];

  } catch {

    return [];

  }

};

/**
 * The parts of a recording that were actually played (seeking over a part does not count). Kept in
 * sessionStorage under `storageKey`, so it survives a reload of the page.
 */
export const useHeardRanges = (storageKey: string) => {

  const [ranges, setRanges] = useState<Range[]>(() => read(storageKey));
  const mark = useCallback((from: number, to: number) => setRanges((previous) => addRange(previous, [from, to])), []);

  useEffect(() => {

    try {

      sessionStorage.setItem(storageKey, JSON.stringify(ranges));

    } catch {

      // Storage full or blocked: what was heard is then only remembered until the next reload.

    }

  }, [storageKey, ranges]);

  return { ranges, mark };

};
